import { IBaseEntity } from './base';
import { IImage } from './image';
import { ITagJoin } from './tag';
import { IText } from './text';
import { IOrgUserCertificateReport } from './user';
import { IVariableDAO } from './variable';

export interface ICertificate extends IBaseEntity {
  name: string;
  textId: number;
  iconId: number;
  imageId: number;
  type: CertificateType;
  status: CertificateStatus;
  tags: ITagJoin[];
}

export interface ICertificateDAO extends ICertificate {
  text: IText;
  image: IImage;
  organisationUserCertificates: IOrgUserCertificateReport[];
}

export enum CertificateType {}
export enum CertificateStatus {
  DELETED = -1,
  NEW = 0,
  PROGRESS = 1,
  COMPLETE = 2,
  ISSUED = 3,
  EXPIRED = 4
}



export interface ICertificateReport extends ICertificateDAO {
  total: number;
  completions: number;
  progress: number;
  organisationUserCertificates: IOrgUserCertificateReport[];
  //CourseVariableReports: ICourseVariableReport[];
}